import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Box, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
const StyledRowTableCell = styled(TableCell)(() => ({
    textAlign: 'left',
    padding: '12px'
}));
const StyledTableCell = styled(TableCell)(() => ({
    textAlign: 'right',
    textTransform: 'capitalize',
    fontWeight: 'bold',
    padding: '12px'
}));
function camelCaseToWords(s) {
    const result = s.replace(/([A-Z])/g, ' $1');
    return result.charAt(0).toUpperCase() + result.slice(1);
}
const HEADERS_WITH_FT_UNITS = ["lateralLength", "nearestOffset"];
const WellSummaryCard = ({ data }) => {
    return (_jsx(_Fragment, { children: _jsxs(Box, { sx: {
                display: "flex",
                flexDirection: "column",
                gap: '10px',
                backgroundColor: 'white',
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                borderRadius: '12px',
                padding: '20px'
            }, children: [_jsx(Typography, { sx: {
                        paddingBottom: '5px',
                        fontWeight: "bold",
                    }, variant: "h6", children: "Summary Well Data" }), _jsx(TableContainer, { children: _jsx(Table, { children: _jsx(TableBody, { children: data && Object.entries(data).map(([key, value]) => (_jsxs(TableRow, { children: [_jsxs(StyledRowTableCell, { children: [camelCaseToWords(key), HEADERS_WITH_FT_UNITS.includes(key) ? " (ft)" : ""] }), _jsx(StyledTableCell, { sx: {}, children: value })] }))) }) }) })] }) }));
};
export default WellSummaryCard;
